import { Component, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { IFilter } from './filter.interface';
import { IColumn } from './column.interface';

@Component( {
    selector: 'context-filter',
    templateUrl: 'filter.component.html',
    styleUrls: ['filter.component.css'],
})

export class ContextFilterComponent {
    filter: string = '';
    lastEmittedFilter = null;
    isShown = false;
    column: IColumn;
    private mouseLocation: { left: number, top: number } = { left: 0, top: 0 };

    @Output() filterChanged = new EventEmitter<IFilter>();
    @ViewChild( 'input' ) input: ElementRef;

    // the css for the container div
    get locationCss() {
        return {
            'position': 'fixed',
            'display': this.isShown ? 'block' : 'none',
            left: this.mouseLocation.left + 'px',
            top: this.mouseLocation.top + 'px'
        };
    }

    onOk( e ) {
        this.onFilterChanged( e );
    }

    onCancel( e ) {
        this.column.showFilter = false;
        this.isShown = false;
    }

    onClear( e ) {
        this.filter = '';
        this.onFilterChanged( e );
    }

    // show the menu and set the location of the mouse
    showFilter( x: number, y: number, column: IColumn ) {
        this.isShown = true;
        this.column = column;
        this.filter = column.filterValue;
        this.mouseLocation = {
            left: x,
            top: y
        }
        setTimeout(() => {
            this.input.nativeElement.focus();
            this.input.nativeElement.select();
        }, 10 );
    }

    onFilterChanged( e ) {
        if ( this.filter === this.lastEmittedFilter ) {
            return;
        }
        this.column.showFilter = false;
        this.isShown = false;

        setTimeout(() => {
            this.filterChanged.emit( {
                column: this.column,
                value: this.filter
            });
            this.lastEmittedFilter = this.filter;
        }, 1 );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Grid/filter.component.ts